// extracted by mini-css-extract-plugin
export default {"container":"formulario_container__sgwK-","form":"formulario_form__ISoY1","boton":"formulario_boton__Q286R","input":"formulario_input__UWVtb"};